import { globalAuthService } from '../contexts/AuthContext';

/**
 * Gestionnaire d'erreurs global pour l'application.
 * Permet de déclencher des notifications et des actions (comme la déconnexion)
 * depuis des services qui n'ont pas accès au contexte React.
 */
class GlobalErrorHandler {
    private static instance: GlobalErrorHandler;
    private logoutFn: (() => void) | null = null;
    private notifyFn: ((title: string, message: string, type: 'error' | 'warning' | 'info' | 'success') => void) | null = null;

    private constructor() { }

    public static getInstance(): GlobalErrorHandler {
        if (!GlobalErrorHandler.instance) {
            GlobalErrorHandler.instance = new GlobalErrorHandler();
        }
        return GlobalErrorHandler.instance;
    }

    /**
     * Enregistre la fonction de déconnexion du contexte d'authentification
     */
    public registerLogout(fn: () => void): void {
        this.logoutFn = fn;
    }

    /**
     * Enregistre la fonction de notification
     */
    public registerNotifier(fn: (title: string, message: string, type: 'error' | 'warning' | 'info' | 'success') => void): void {
        this.notifyFn = fn;
    }

    /**
     * Gère une perte de session
     */
    public handleSessionLost(): void {
        if (globalAuthService && globalAuthService.handleSessionExpired) {
            globalAuthService.handleSessionExpired();
            return;
        }

        if (this.notifyFn) {
            this.notifyFn(
                "Session expirée",
                "Votre session a expiré ou est invalide. Vous allez être déconnecté.",
                'error'
            );
        }

        // Petit délai pour laisser le temps à l'utilisateur de voir le message
        setTimeout(() => {
            if (this.logoutFn) {
                this.logoutFn();
            }
            const pathname = typeof window !== 'undefined' ? window.location.pathname : '';
            const appSegment = pathname.split('/')[1];
            const targetApp = (appSegment && appSegment.length > 0 && appSegment !== 'login') ? appSegment : 'Planning';
            window.location.href = `/${targetApp}/login`;
        }, 2500);
    }

    /**
     * Affiche une erreur globale
     */
    public showError(title: string, message: string): void {
        if (this.notifyFn) {
            this.notifyFn(title, message, 'error');
        } else {
            console.error(`Global Error: ${title} - ${message}`);
        }
    }
}

export const globalErrorHandler = GlobalErrorHandler.getInstance();
